import * as React from 'react';
import styled from 'styled-components';
import { COLORS } from 'styles/colors';
import { clearFormat } from 'utilities/util';
import { convertToMonetary } from 'utilities/util';

const SErrorMessage = styled.span`
    color: ${COLORS.RED};
    margin: 5px 0;
`;
const SLabel = styled.span`
    display: block;
`;
const SDiv = styled.div`
    position:relative
`;
const ALink = styled.a`
    display: inline-block;
    position: absolute;
    top: 1.6rem!important;
    text-align: center;
    right: 0.1rem;
    line-height: 2rem;
    width: 1.8rem;
    height: 1.8rem;
    background: white;
    text-decoration: none;
`;
interface IInput {
    id?:string;
    label: string;
    value?: string | number;
    disabled?: boolean;
    error?: any;
    hasError?: boolean;
    type?: string;
    pattern?: string;
    formatNumber?: number;
    readonly?:boolean;
    className?:string;
    placeholder?:string;
    maxlength?: number;
    onChange?: (e:any) => void;
    onKeyUp?: (e:any) => void;
    onClose?: (e:any) => void
    showClose?: boolean,
    autocomplete?: boolean
}
interface IState{
    isInvalid: boolean,
    val: any
}

export class Input extends React.Component<IInput, IState> {
    
    constructor(props: IInput) {
        super(props);
        this.state = {
            isInvalid: false, 
            val: React.createRef()
        }
    }
    public componentDidMount(){
        if(this.state.val.current && this.props.value !== this.state.val.current.value && !this.props.readonly){
            this.checkAndSetVal(this.props.value)
            this.setState({isInvalid: false})
        }
    }
    public componentDidUpdate(props:any){
        if(this.props.value !== props.value && !this.props.readonly){
            this.checkAndSetVal(this.props.value)
        }
        if(this.props.hasError !== props.hasError){
            this.setState({isInvalid: this.props.hasError?this.props.hasError:false})
        }
    }
    public onFormatChange = (value:any) => {
        const fieldValue = value.currentTarget.value;
        let check:boolean = fieldValue.length > 0;
        if(check && this.props.value === value.currentTarget.value){
            return
        }
        let re:any = true;
        if(this.props.pattern){
            re = new RegExp(this.props.pattern);
            re = re.test(fieldValue)
            check = check && re;
        }
        if(check && re){
            this.setState({isInvalid: false});
        }else{
            this.setState({isInvalid: true})
        }
        if(this.props.onChange) {
            const notEmpty= fieldValue? fieldValue.toString() === 'NaN'?0:fieldValue: '';
            this.checkAndSetVal(notEmpty)
            this.props.onChange(notEmpty)
        }
    }
    public checkAndSetVal = (val:any) =>{
        const newVal = clearFormat(val);
        if(this.props.formatNumber && this.props.formatNumber === 2 && !isNaN(newVal)){
            let thisVal = newVal
            if(newVal && this.props.pattern){
                let re:any = new RegExp(this.props.pattern);
                re = re.test(newVal)
                thisVal = !re? thisVal: convertToMonetary(val);
            }
            this.state.val.current.value = convertToMonetary(val);
        }else if(this.props.formatNumber && !isNaN(newVal)){
            let thisVal = newVal
            if(newVal && this.props.pattern){
                let re:any = new RegExp(this.props.pattern);
                re = re.test(newVal)
                thisVal = !re? thisVal: parseFloat(val).toFixed(this.props.formatNumber)
            }
            this.state.val.current.value = thisVal
        }else if(this.props.formatNumber && isNaN(newVal)){
            this.state.val.current.value = 0
        }
        else{
            this.state.val.current.value = val
        }
        this.setState({val: this.state.val})
    }
    public getClass =() => {
        return this.state.isInvalid? 'form-control error': 'form-control';
    }
    public getInput = () => {
        if(this.props.readonly){
            return <SLabel>{this.props.value}</SLabel>
        }
        return <input 
                    id={`input-${this.props.id}`}
                    placeholder={this.props.placeholder}
                    className={this.getClass()}
                    disabled={this.props.disabled}
                    readOnly={this.props.readonly}
                    ref={this.state.val}
                    type={this.props.type}
                    maxLength={this.props.maxlength}
                    pattern={this.props.pattern}
                    onKeyUp={(e:any)=>{ 
                        if((e.code === 13 || e.key === 'Enter') && this.props.onKeyUp){
                            this.props.onKeyUp(e.currentTarget.value)
                        }
                    }}
                    defaultValue={this.props.value}
                    onBlur={this.onFormatChange}
                    autoComplete = {this.props.autocomplete === false ? 'off' : 'on'}
                /> 
    }
    public render(){
        return ( 
            <div className={this.props.className? this.props.className: 'col-30'}>
                <SDiv className="form-group" id={`input-group-${this.props.id}`}>
                    <label><SLabel>{this.props.label}</SLabel></label>
                    <span className="custom-span">
                        {this.getInput()}
                        {this.props.showClose &&
                            <ALink className="fa fa-times" onClick={this.props.onClose}>&nbsp;</ALink>
                        }
                        <SLabel>{this.props.error && this.state.isInvalid && <SErrorMessage>{this.props.error}</SErrorMessage>}</SLabel>
                    </span>
                </SDiv>
            </div>
        );
    }
};
